var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('Loading',{style:({zIndex: 9999}),attrs:{"visible":_vm.isLoading}}),_c('router-view',{attrs:{"visible":!_vm.isLoading}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }